export default function FeatureGrid() {
  const features = [
    {
      icon: 'ri-time-line',
      title: 'Save Hours of Searching',
      description: 'Stop scrolling through endless listings. Our spreadsheet organizes everything by category so you find what you need in seconds, not hours.',
    },
    {
      icon: 'ri-star-line',
      title: 'Curated Product Selection',
      description: 'Every entry is handpicked and verified. No spam, no dead links — just quality finds that are worth your time and money.',
    },
    {
      icon: 'ri-scales-3-line',
      title: 'Compare Across Sources',
      description: 'See products from Kakobuy, CSSBuy, Superbuy, and Oopbuy side by side. Make informed decisions with cross-platform comparison data.',
    },
    {
      icon: 'ri-book-open-line',
      title: 'Learn Before You Buy',
      description: 'Access detailed buying guides, QC checklists, and safety tips that walk you through the entire shopping process from start to finish.',
    },
    {
      icon: 'ri-refresh-line',
      title: 'Regularly Updated',
      description: 'The database is refreshed frequently with new finds, updated prices, and fresh categories. You will always have the latest information.',
    },
    {
      icon: 'ri-shield-flash-line',
      title: 'Safety First Approach',
      description: 'Every resource includes safety information, risk assessments, and tips to avoid common pitfalls when shopping online.',
    },
  ];

  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 lg:px-10 bg-background-100">
      <div className="mb-12 md:mb-16">
        <span className="text-xs font-semibold text-accent-500 uppercase tracking-widest">
          Why Choose Us
        </span>
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 mt-3 leading-tight max-w-2xl">
          Why Use Our Spreadsheet Database?
        </h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {features.map((feature) => (
          <div
            key={feature.title}
            className="group bg-background-50 rounded-2xl p-6 md:p-7 border border-background-200/60 hover:border-accent-200/60 transition-all duration-300 cursor-default"
          >
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-5 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
              <i className={`${feature.icon} text-xl`}></i>
            </div>
            <h3 className="font-heading font-semibold text-foreground-900 text-lg mb-2">
              {feature.title}
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {feature.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}